<template>
    <div class="positionRelative">
        <div class="page success">
            <h2>{{ __('page_success.title') }}</h2>

            <div class="elementInfo">
                <span>{{ __('page_success.text') }}</span>
            </div>
        </div>
    </div>
</template>

<script>
    import Lang from "../mixins/Lang";

    export default {
        name: "Complete",

        created () {
            window.sessionStorage.clear();
        },

        mixins: [Lang],
    }
</script>